// Exports
export default {
	"continueInBrowserButton": "continueInBrowserButton_-wewF",
	"displayNameInput": "displayNameInput_SW-iJ",
	"contentOuterWrapper": "contentOuterWrapper_-qi7J",
	"withGlobalBar": "withGlobalBar_F-yDK",
	"withOverlayChangeAccount": "withOverlayChangeAccount_NyTLc",
	"contentInnerWrapper": "contentInnerWrapper_Xg-dy",
	"contentInnerWrapper_defaultTheme": "contentInnerWrapper_defaultTheme_FOe7d",
	"contentInnerWrapper_videoPreview": "contentInnerWrapper_videoPreview_7--+s",
	"closeButton": "closeButton_QX6oA",
	"toolbarWrapper": "toolbarWrapper_xveqO",
	"spinnerContainer": "spinnerContainer_dP9Pg",
	"showSpinner": "showSpinner_xAvKY",
	"overlayContainer": "overlayContainer_htJGu",
	"waitContinueContainer": "waitContinueContainer_Tb-2H",
	"withPaddings": "withPaddings_UOoFJ",
	"premiumButtonDisabled": "premiumButtonDisabled_xzGwi",
	"overlayContainerJoin": "overlayContainerJoin_hYyyR",
	"waitContinueText": "waitContinueText_Qfxwb",
	"participantContent": "participantContent_uc-KU",
	"displayNameBlock": "displayNameBlock_Ud+LC",
	"overlayTooltip": "overlayTooltip_qlEMU",
	"overlayTooltipText": "overlayTooltipText_eW0WV",
	"userInfoBlock": "userInfoBlock_-p+RS",
	"userDisplayName": "userDisplayName_FhJ8x",
	"userLogin": "userLogin_rNHNe",
	"changeAccountBlock": "changeAccountBlock_Z4C4G",
	"joinMeetingButton": "joinMeetingButton_M38VH",
	"connectionStatusTextWrapper": "connectionStatusTextWrapper_3bBuh",
	"connectionStatusText": "connectionStatusText_gvy54"
};
